<template>
  <div>
    <div class="section-associate-logo foot_content">
      <div class="container foot_logo">
        <div class="associate-logo-item">
          <div class="item_icon">
            <svg
              width="42px"
              height="42px"
              viewBox="0 0 42 42"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Home"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Page1-Home"
                  transform="translate(-371.000000, -6470.000000)"
                >
                  <g
                    id="底部固定内容"
                    transform="translate(372.000000, 6467.000000)"
                  >
                    <g
                      id="icon_Business"
                      transform="translate(0.000000, 4.000000)"
                    >
                      <circle
                        id="椭圆形"
                        stroke="#000000"
                        stroke-width="2"
                        cx="20"
                        cy="20"
                        r="20"
                      ></circle>
                      <path
                        d="M16.5614253,12.4147755 L20.5263823,16.3541833 L26.6666667,22.4017011 L24.9473665,24.0949723 L20.4209739,19.6371637 C20.2807435,19.4988841 20.0700981,19.4988841 19.9297392,19.6371637 C19.7895088,19.7754011 19.7895088,19.982694 19.9297392,20.1209314 L24.4561746,24.5787822 L22.7368744,26.2720956 L18.4210844,22.0561286 C18.2807255,21.9178912 18.0702514,21.9178912 17.9298497,22.0561286 C17.7894908,22.1944082 17.7894908,22.4017011 17.9298497,22.5399385 L22.2105178,26.7559054 L21.263213,27.6890607 C20.8420935,28.1036464 20.1753351,28.1036464 19.7895088,27.6890607 L14.3858838,22.4017011 L10.421141,18.4622511 C9.85961968,17.9092593 9.85961968,17.045286 10.421141,16.4924629 L14.5614073,12.4147755 C15.1227145,11.8617415 15.9999469,11.8617415 16.5614253,12.4147755 Z M26.1211345,12.4209788 L30.2471234,16.5614014 C30.8065144,17.1227493 30.8065144,17.9999358 30.2471234,18.5262904 L26.7855661,22 L20.6666667,15.8946884 L24.128096,12.4209788 C24.687615,11.8596737 25.5617862,11.8596737 26.1211345,12.4209788 Z"
                        id="形状结合"
                        fill="#000000"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="item_right">
            <div class="title_text">Business Partnership</div>
            <p>
              Professional consultant team tailors the one-stop custom solution
              to fit your business needs.
            </p>
          </div>
        </div>
        <div class="line"></div>
        <div class="associate-logo-item">
          <div class="item_icon">
            <svg
              width="42px"
              height="42px"
              viewBox="0 0 42 42"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Home"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Page1-Home"
                  transform="translate(-815.000000, -6470.000000)"
                >
                  <g
                    id="底部固定内容"
                    transform="translate(372.000000, 6467.000000)"
                  >
                    <g
                      id="icon_Premium"
                      transform="translate(444.000000, 4.000000)"
                    >
                      <g id="编组-8备份" stroke="#000000" stroke-width="2">
                        <circle id="椭圆形" cx="20" cy="20" r="20"></circle>
                      </g>
                      <path
                        d="M15.4221506,21.0666667 C15.5566412,21.0666667 15.6666667,21.1821958 15.6666667,21.3233009 L15.6666667,25.9433376 C15.6666667,26.0845555 15.5566412,26.2 15.4221506,26.2 L12.2444355,26.2 C12.1100524,26.2 12,26.0845555 12,25.9433376 L12,21.3233009 C12,21.1821958 12.1100524,21.0666667 12.2444355,21.0666667 L15.4221506,21.0666667 Z M20.5555573,17.4 C20.6900518,17.4 20.8,17.5164147 20.8,17.6587909 L20.8,17.6587909 L20.8,25.9411807 C20.8,26.0835853 20.6900518,26.2 20.5555573,26.2 L20.5555573,26.2 L17.3777491,26.2 C17.2432546,26.2 17.1333333,26.0835853 17.1333333,25.9411807 L17.1333333,25.9411807 L17.1333333,17.6587909 C17.1333333,17.5164147 17.2432546,17.4 17.3777491,17.4 L17.3777491,17.4 Z M23.8978304,9.4931521 C24.0088396,9.28006041 24.1907029,9.28006041 24.3017121,9.4931521 L24.3017121,9.4931521 L26.6193232,13.9354273 C26.7303324,14.148519 26.6393366,14.3228049 26.4173183,14.3228049 L26.4173183,14.3228049 L25.616115,14.3228049 L25.616115,25.941805 C25.616115,26.0838662 25.5111278,26.2 25.3828983,26.2 L25.3828983,26.2 L22.8171566,26.2 C22.6888247,26.2 22.5839144,26.0838662 22.5839144,25.941805 L22.5839144,25.941805 L22.5839144,14.3228049 L21.7827367,14.3228049 C21.5604108,14.3228049 21.4697226,14.148519 21.5807318,13.9354273 L21.5807318,13.9354273 Z"
                        id="形状结合"
                        fill="#0A0B0C"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="item_right">
            <div class="title_text">Premium Support</div>
            <p>We’ll always do our best to get back to you within 24 hours.</p>
          </div>
        </div>
        <div class="line"></div>
        <div class="associate-logo-item">
          <div class="item_icon">
            <svg
              width="42px"
              height="42px"
              viewBox="0 0 42 42"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Home"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="Page1-Home"
                  transform="translate(-1231.000000, -6470.000000)"
                >
                  <g
                    id="底部固定内容"
                    transform="translate(372.000000, 6467.000000)"
                  >
                    <g
                      id="icon_Product"
                      transform="translate(860.000000, 4.000000)"
                    >
                      <circle
                        id="椭圆形"
                        stroke="#000000"
                        stroke-width="2"
                        cx="20"
                        cy="20"
                        r="20"
                      ></circle>
                      <path
                        d="M20.3420233,10.6666667 L28,14.181801 L28,19.4545161 C28,24.3309947 24.7254934,28.880027 20.3420233,30 C15.9412816,28.8972851 12.6666667,24.3309947 12.6666667,19.4545161 L12.6666667,14.181801 L20.3420233,10.6666667 Z M19.9999609,16 C17.7833652,16 16,17.8736331 16,20.1635959 C16,22.4535858 17.7833652,24.3271104 19.9999609,24.3271104 C20.4999365,24.3271104 20.9666568,24.2230212 21.4166843,24.0669416 L21.4166843,24.0669416 L22.6333289,25.3333333 L23.583332,24.3444586 L22.5999694,23.320996 L22.7658962,23.1635357 C23.5208646,22.4066766 24,21.3455615 24,20.1635959 C24,17.8562577 22.2166609,16 19.9999609,16 Z M19.9999609,17.3333333 C21.4666204,17.3333333 22.6666667,18.5333796 22.6666667,20.0000391 C22.6666667,20.850061 22.2666947,21.5999792 21.6499268,22.0833622 L21.6499268,22.0833622 L20.7499833,21.1833145 L19.7999619,22.1333099 L20.3166261,22.649974 L20.2123056,22.6617207 C20.140701,22.6666667 20.0666273,22.6666667 19.9999609,22.6666667 C18.5333014,22.6666667 17.3333333,21.4666986 17.3333333,20.0000391 C17.3333333,18.5333796 18.5333014,17.3333333 19.9999609,17.3333333 Z"
                        id="形状结合"
                        fill="#000000"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="item_right">
            <div class="title_text">Product Warranty</div>
            <p>
              All custom products come with extended warranty that covers
              defects in materials and workmanship.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="footer-widgets">
      <div class="container">
        <div class="inner-wrapper">
          <div class="footer-active-5 footer-widget-area">
            <div class="footer-logo" @click="nextIndex">
              <svg
                class="foot_log"
                version="1.1"
                id="图层_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 140 190"
                style="enable-background: new 0 0 140 190"
                xml:space="preserve"
              >
                <g>
                  <linearGradient
                    id="SVGID_1_"
                    gradientUnits="userSpaceOnUse"
                    x1="37.0194"
                    y1="64.5165"
                    x2="86.305"
                    y2="64.5165"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #7b420c" />
                    <stop offset="0.12" style="stop-color: #8b4c11" />
                    <stop offset="0.26" style="stop-color: #b66913" />
                    <stop offset="0.34" style="stop-color: #d48004" />
                    <stop offset="0.4" style="stop-color: #f39c00" />
                    <stop offset="0.87" style="stop-color: #ffe653" />
                    <stop offset="1" style="stop-color: #ffe653" />
                  </linearGradient>
                  <path
                    class="st0"
                    d="M61.6,152.9c-9.6,1.1-12.8,1.6-13,2.3l1.3,4h17.3l2.1-7.4C67.6,152.2,65.3,152.5,61.6,152.9 M63.6,139.9
		c-11.4,2.5-18.3,4.2-17.9,6.3l1.9,5.9c-0.1-1.2,4.7-2.1,14.8-3.7c2.8-0.4,5.7-0.9,8.5-1.6l2.7-9.4C70.3,138.4,67,139.2,63.6,139.9
		 M66.3,126.5c-15.2,4.2-24.3,7-23.4,10.5l1.8,5.9c-0.4-2.5,6-4.4,19.9-7.8c3.5-0.7,7-1.7,10.4-3l2.7-9.4
		C74.1,124.3,70.2,125.6,66.3,126.5 M67.8,113.4c-17.6,5.5-29,9.5-27.8,14.4l1.9,5.9c-0.8-3.7,6.8-6.6,24.1-11.6
		c4.6-1.2,9-2.8,13.4-4.6l2.8-9.6C78.4,109.9,73.9,111.4,67.8,113.4 M69.3,100.2c-23.5,8-33.7,12.5-32.1,18.4l1.8,5.9
		c-1.2-5.3,8.8-9.2,30.1-16.1c8.3-2.7,12.4-4.5,14.4-5.6l2.8-9.6C81.9,95.8,76.7,97.7,69.3,100.2"
                  />

                  <linearGradient
                    id="SVGID_2_"
                    gradientUnits="userSpaceOnUse"
                    x1="24.775"
                    y1="131.1465"
                    x2="88.665"
                    y2="131.1465"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #002870" />
                    <stop offset="8.000000e-02" style="stop-color: #00357c" />
                    <stop offset="0.22" style="stop-color: #00589b" />
                    <stop offset="0.41" style="stop-color: #008fcc" />
                    <stop offset="0.53" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #98d5f5" />
                  </linearGradient>
                  <path
                    class="st1"
                    d="M70.5,86.6C43.8,96.2,32.2,101.7,34,109l1.9,5.9c-1.6-7,12-12.3,34.5-20.1c10-3.5,14.8-5.8,17.1-7.1l2.8-9.6
		C85.2,81.2,79.2,83.5,70.5,86.6 M72.1,73.5c-29.5,11-43.1,17.8-40.9,26.4l1.9,5.9C31.2,97.9,43.5,92,71.8,81.7
		c11.8-4.3,17.3-7,19.9-8.6l2.8-9.7C88.7,67.1,81.9,69.8,72.1,73.5 M73.6,60.3C40.9,72.9,25.8,80.7,28.3,90.7l1.9,5.9
		c-2.2-9.2,11.5-16.1,43-28.1c13.6-5.1,19.9-8.3,22.8-10.2l2.8-9.8C92.3,53,84.7,56,73.6,60.3 M75.2,47.1
		c-36,14.2-52.6,23-49.8,34.4l1.9,5.9c-2.5-10.6,12.5-18.4,47.3-32c15.4-6,22.5-9.7,25.7-11.8l2.8-9.8C95.7,38.8,87,42.4,75.2,47.1
		 M76.8,33.9C43.4,47.3,18.3,58.7,22.5,72.4l1.8,5.9c-2.9-11.9,14.3-21.1,51.4-35.8c17.4-6.9,25.2-11.1,28.7-13.5l2.9-9.9
		C99.3,24.7,89.8,28.7,76.8,33.9 M78.5,20.7C42.3,35.5,15,48,19.6,63.2l1.9,5.9c-3.3-13.3,15.3-23.4,55.5-39.7
		c19.3-7.8,27.9-12.5,31.8-15.1l2.9-9.9C103.6,10,94.4,14.2,78.5,20.7"
                  />

                  <linearGradient
                    id="SVGID_3_"
                    gradientUnits="userSpaceOnUse"
                    x1="78.225"
                    y1="51.1615"
                    x2="97.045"
                    y2="51.1615"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st2"
                    d="M78.2,138c8.5,2.4,15.9,4.6,18.1,6.9l0.7-2.6c-2-2.8-9.4-5.4-17.8-8L78.2,138z"
                  />

                  <linearGradient
                    id="SVGID_4_"
                    gradientUnits="userSpaceOnUse"
                    x1="76.715"
                    y1="46.7565"
                    x2="95.925"
                    y2="46.7565"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st3"
                    d="M76.7,143.2c8.5,2,16.2,3.7,18.5,5.6l0.7-2.6c-2.2-2.5-9.7-4.8-18.1-7L76.7,143.2z"
                  />

                  <linearGradient
                    id="SVGID_5_"
                    gradientUnits="userSpaceOnUse"
                    x1="75.245"
                    y1="42.1015"
                    x2="94.785"
                    y2="42.1015"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st4"
                    d="M75.2,148.3c8.4,1.5,16.4,2.9,18.8,4.4l0.7-2.6c-2.3-1.9-10.1-3.8-18.5-5.6L75.2,148.3z"
                  />

                  <linearGradient
                    id="SVGID_6_"
                    gradientUnits="userSpaceOnUse"
                    x1="73.695"
                    y1="37.4865"
                    x2="93.655"
                    y2="37.4865"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st5"
                    d="M73.7,153.7c8.3,1.1,16.6,2,19.2,3l0.8-2.6c-2.5-1.5-10.6-2.9-18.9-4.2L73.7,153.7z"
                  />

                  <linearGradient
                    id="SVGID_7_"
                    gradientUnits="userSpaceOnUse"
                    x1="84.195"
                    y1="68.7515"
                    x2="101.495"
                    y2="68.7515"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st6"
                    d="M84.2,117.3c8.3,3.9,14.8,7.8,16.6,12.1l0.7-2.5c-1.7-4.1-8.1-8.1-16.5-12.2L84.2,117.3z"
                  />

                  <linearGradient
                    id="SVGID_8_"
                    gradientUnits="userSpaceOnUse"
                    x1="82.765"
                    y1="64.5865"
                    x2="100.395"
                    y2="64.5865"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st7"
                    d="M82.8,122.3c8.3,3.5,15,7.1,16.9,11l0.7-2.5c-1.8-4.1-8.4-7.9-16.7-11.7L82.8,122.3z"
                  />

                  <linearGradient
                    id="SVGID_9_"
                    gradientUnits="userSpaceOnUse"
                    x1="79.825"
                    y1="55.7065"
                    x2="98.175"
                    y2="55.7065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st8"
                    d="M79.8,132.4c8.4,2.8,15.6,5.5,17.6,8.5l0.7-2.5c-2-3.2-9-6.2-17.4-9.3L79.8,132.4z"
                  />

                  <linearGradient
                    id="SVGID_10_"
                    gradientUnits="userSpaceOnUse"
                    x1="81.305"
                    y1="60.1915"
                    x2="99.275"
                    y2="60.1915"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st9"
                    d="M81.3,127.3c8.4,3.2,15.3,6.3,17.3,9.8l0.7-2.5c-1.8-3.7-8.7-7.1-17-10.5L81.3,127.3z"
                  />

                  <linearGradient
                    id="SVGID_11_"
                    gradientUnits="userSpaceOnUse"
                    x1="72.075"
                    y1="33.3565"
                    x2="92.505"
                    y2="33.3565"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #f1ae00" />
                    <stop offset="0.25" style="stop-color: #e48c00" />
                    <stop offset="0.38" style="stop-color: #cd770b" />
                    <stop offset="0.45" style="stop-color: #ba6713" />
                    <stop offset="0.75" style="stop-color: #834011" />
                    <stop offset="0.87" style="stop-color: #62340a" />
                    <stop offset="1" style="stop-color: #492f0d" />
                    <stop offset="1" style="stop-color: #53260b" />
                  </linearGradient>
                  <path
                    class="st10"
                    d="M72.1,159.3h20.1l0.3-1.2c-2.6-0.9-11.2-1.7-19.3-2.6L72.1,159.3z"
                  />

                  <linearGradient
                    id="SVGID_12_"
                    gradientUnits="userSpaceOnUse"
                    x1="14"
                    y1="17.8865"
                    x2="14"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <path
                    class="st11"
                    d="M11.6,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7V175.1z M8.7,172.9v12.6h2.9v-4.7h2.8
		c3,0,4.8-1.8,4.8-3.9s-1.8-3.9-4.8-3.9L8.7,172.9z"
                  />

                  <linearGradient
                    id="SVGID_13_"
                    gradientUnits="userSpaceOnUse"
                    x1="26.535"
                    y1="17.8865"
                    x2="26.535"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <polygon
                    class="st12"
                    points="21.7,172.9 21.7,185.5 31.4,185.5 31.4,183.3 24.6,183.3 24.6,180.2 31.4,180.2 31.4,178 24.6,178
		24.6,175.1 31.4,175.1 31.4,172.9 	"
                  />

                  <linearGradient
                    id="SVGID_14_"
                    gradientUnits="userSpaceOnUse"
                    x1="39.05"
                    y1="17.8865"
                    x2="39.05"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <path
                    class="st13"
                    d="M39.1,176.6l1.8,4.6h-3.6L39.1,176.6z M37.9,172.9l-5.3,12.6h3l0.9-2.2h5.2l0.9,2.2h3l-5.4-12.6H37.9z"
                  />

                  <linearGradient
                    id="SVGID_15_"
                    gradientUnits="userSpaceOnUse"
                    x1="52.9"
                    y1="17.8865"
                    x2="52.9"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <path
                    class="st14"
                    d="M50.2,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7V175.1z M47.3,172.9v12.6h2.9v-5h2.1l2.9,5h3.3
		l-3.3-5.4c1.5-0.4,2.6-1.7,2.7-3.3c0-2.1-1.8-3.9-4.8-3.9H47.3z"
                  />

                  <linearGradient
                    id="SVGID_16_"
                    gradientUnits="userSpaceOnUse"
                    x1="65.615"
                    y1="17.8865"
                    x2="65.615"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <polygon
                    class="st15"
                    points="60.8,172.9 60.8,185.5 70.4,185.5 70.4,183.3 63.7,183.3 63.7,172.9 	"
                  />

                  <linearGradient
                    id="SVGID_17_"
                    gradientUnits="userSpaceOnUse"
                    x1="83.07"
                    y1="17.8865"
                    x2="83.07"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <path
                    class="st16"
                    d="M80.4,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7V175.1z M77.5,172.9v12.6h2.9v-5h2.1l2.9,5h3.3
		l-3.3-5.4c1.5-0.4,2.6-1.7,2.7-3.3c0-2.1-1.8-3.9-4.8-3.9H77.5z"
                  />

                  <linearGradient
                    id="SVGID_18_"
                    gradientUnits="userSpaceOnUse"
                    x1="-8295.3525"
                    y1="520.3867"
                    x2="-8292.6221"
                    y2="520.3867"
                    gradientTransform="matrix(0 12.02 -12.02 0 6347.4888 99870.2344)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.34" style="stop-color: #0068bb" />
                    <stop offset="0.4" style="stop-color: #006dbf" />
                    <stop offset="0.48" style="stop-color: #007dc9" />
                    <stop offset="0.56" style="stop-color: #0096d9" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <rect
                    x="91"
                    y="172.9"
                    class="st17"
                    width="2.9"
                    height="12.6"
                  />

                  <linearGradient
                    id="SVGID_19_"
                    gradientUnits="userSpaceOnUse"
                    x1="101.585"
                    y1="17.8865"
                    x2="101.585"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <polygon
                    class="st18"
                    points="104.5,172.9 101.6,181.1 98.6,172.9 95.7,172.9 100.5,185.5 102.6,185.5 107.5,172.9 	"
                  />

                  <linearGradient
                    id="SVGID_20_"
                    gradientUnits="userSpaceOnUse"
                    x1="114.135"
                    y1="17.8865"
                    x2="114.135"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <polygon
                    class="st19"
                    points="109.3,172.9 109.3,185.5 119,185.5 119,183.3 112.2,183.3 112.2,180.2 119,180.2 119,178 112.2,178
		112.2,175.1 119,175.1 119,172.9 	"
                  />

                  <linearGradient
                    id="SVGID_21_"
                    gradientUnits="userSpaceOnUse"
                    x1="127.35"
                    y1="17.8865"
                    x2="127.35"
                    y2="5.3065"
                    gradientTransform="matrix(1 0 0 -1 0 190.7765)"
                  >
                    <stop offset="0" style="stop-color: #0068bb" />
                    <stop offset="0.14" style="stop-color: #006dbe" />
                    <stop offset="0.3" style="stop-color: #007cc8" />
                    <stop offset="0.47" style="stop-color: #0094d8" />
                    <stop offset="0.64" style="stop-color: #00b4ed" />
                    <stop offset="1" style="stop-color: #6fc2f5" />
                  </linearGradient>
                  <path
                    class="st20"
                    d="M124.7,175.1h2.7c1.3,0,2.1,0.7,2.1,1.7s-0.8,1.7-2.1,1.7h-2.7L124.7,175.1z M121.8,172.9v12.6h2.9v-5h2.1
		l2.9,5h3.3l-3.3-5.4c1.5-0.4,2.7-1.7,2.7-3.3c0-2.1-1.8-3.9-4.8-3.9H121.8z"
                  />
                </g>
              </svg>
            </div>
          </div>
          <div class="footer-active-4 footer-widget-area">
            <h3 class="widget-title">Custom Brand</h3>
            <div class="footer-logo" @click="nextHoming">
              <img alt="Logo" src="../assets/images/logo_foot_Homing.png" />
            </div>
          </div>
          <div class="footer-active-4 footer-widget-area">
            <h3 class="widget-title">More</h3>
            <ul>
              <li>
                <router-link
                  :to="{ path: '../index' }"
                  v-show="path != '/index'"
                >
                  <div class="click_icon">
                    <svg width="4px" height="5px" viewBox="0 0 4 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 5px;">
                        <title>icon_right_foot</title>
                        <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Page1-Home" transform="translate(-855.000000, -6751.000000)" fill="#727272" fill-rule="nonzero">
                                <g id="foot" transform="translate(0.000000, 6640.000000)">
                                    <path d="M858.949618,113.412755 L855.193893,111.020551 C855.112977,110.969481 855,111.019207 855,111.107907 L855,111.738212 C855,111.875294 855.074809,112.005655 855.201527,112.086291 L857.421374,113.500111 L855.201527,114.91393 C855.074809,114.994566 855,115.123584 855,115.26201 L855,115.892315 C855,115.979671 855.112977,116.03074 855.193893,115.979671 L858.949618,113.587467 C859.016794,113.544461 859.016794,113.455761 858.949618,113.412755 Z" id="icon_right_foot"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </div>
                  Home</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ path: '../ourStrength' }"
                  v-show="path != '/ourStrength'"
                >
                  <div class="click_icon">
                    <svg width="4px" height="5px" viewBox="0 0 4 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 5px;">
                        <title>icon_right_foot</title>
                        <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Page1-Home" transform="translate(-855.000000, -6751.000000)" fill="#727272" fill-rule="nonzero">
                                <g id="foot" transform="translate(0.000000, 6640.000000)">
                                    <path d="M858.949618,113.412755 L855.193893,111.020551 C855.112977,110.969481 855,111.019207 855,111.107907 L855,111.738212 C855,111.875294 855.074809,112.005655 855.201527,112.086291 L857.421374,113.500111 L855.201527,114.91393 C855.074809,114.994566 855,115.123584 855,115.26201 L855,115.892315 C855,115.979671 855.112977,116.03074 855.193893,115.979671 L858.949618,113.587467 C859.016794,113.544461 859.016794,113.455761 858.949618,113.412755 Z" id="icon_right_foot"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </div>
                  Our Strength</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ path: '../projects' }"
                  v-show="path != '/projects'"
                >
                  <div class="click_icon">
                    <svg width="4px" height="5px" viewBox="0 0 4 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 5px;">
                        <title>icon_right_foot</title>
                        <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Page1-Home" transform="translate(-855.000000, -6751.000000)" fill="#727272" fill-rule="nonzero">
                                <g id="foot" transform="translate(0.000000, 6640.000000)">
                                    <path d="M858.949618,113.412755 L855.193893,111.020551 C855.112977,110.969481 855,111.019207 855,111.107907 L855,111.738212 C855,111.875294 855.074809,112.005655 855.201527,112.086291 L857.421374,113.500111 L855.201527,114.91393 C855.074809,114.994566 855,115.123584 855,115.26201 L855,115.892315 C855,115.979671 855.112977,116.03074 855.193893,115.979671 L858.949618,113.587467 C859.016794,113.544461 859.016794,113.455761 858.949618,113.412755 Z" id="icon_right_foot"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </div>
                  Projects</router-link
                >
              </li>
              <li>
                <router-link
                  :to="{ path: '../homingSeries' }"
                  v-show="path != '/homingSeries'"
                >
                  <div class="click_icon">
                    <svg width="4px" height="5px" viewBox="0 0 4 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 5px;">
                        <title>icon_right_foot</title>
                        <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Page1-Home" transform="translate(-855.000000, -6751.000000)" fill="#727272" fill-rule="nonzero">
                                <g id="foot" transform="translate(0.000000, 6640.000000)">
                                    <path d="M858.949618,113.412755 L855.193893,111.020551 C855.112977,110.969481 855,111.019207 855,111.107907 L855,111.738212 C855,111.875294 855.074809,112.005655 855.201527,112.086291 L857.421374,113.500111 L855.201527,114.91393 C855.074809,114.994566 855,115.123584 855,115.26201 L855,115.892315 C855,115.979671 855.112977,116.03074 855.193893,115.979671 L858.949618,113.587467 C859.016794,113.544461 859.016794,113.455761 858.949618,113.412755 Z" id="icon_right_foot"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </div>
                  HOMING Series</router-link>
              </li>
              <li>
                <router-link
                  :to="{ path: '../contactUs' }"
                  v-show="path != '/contactUs'"
                >
                  <div class="click_icon">
                    <svg width="4px" height="5px" viewBox="0 0 4 5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin-top: 5px;">
                        <title>icon_right_foot</title>
                        <g id="Home" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Page1-Home" transform="translate(-855.000000, -6751.000000)" fill="#727272" fill-rule="nonzero">
                                <g id="foot" transform="translate(0.000000, 6640.000000)">
                                    <path d="M858.949618,113.412755 L855.193893,111.020551 C855.112977,110.969481 855,111.019207 855,111.107907 L855,111.738212 C855,111.875294 855.074809,112.005655 855.201527,112.086291 L857.421374,113.500111 L855.201527,114.91393 C855.074809,114.994566 855,115.123584 855,115.26201 L855,115.892315 C855,115.979671 855.112977,116.03074 855.193893,115.979671 L858.949618,113.587467 C859.016794,113.544461 859.016794,113.455761 858.949618,113.412755 Z" id="icon_right_foot"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                  </div>
                  Contact Us</router-link
                >
              </li>
            </ul>
          </div>
          <div class="contavctus">
            <h3 class="widget-title">Contact Us</h3>
            <div id="gallery-1" class="gallery gallery-columns-3">
              <ul>
                <li>
                  <div class="click_icon">
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 18 18"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="Home"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Page1-Home"
                          transform="translate(-1174.000000, -6743.000000)"
                        >
                          <g
                            id="foot"
                            transform="translate(0.000000, 6640.000000)"
                          >
                            <g
                              id="icon_phone_foot"
                              transform="translate(1175.000000, 104.000000)"
                            >
                              <path
                                d="M5.36389876,4.30769231 C4.86738145,4.49730192 4.47924772,4.89467908 4.30769231,5.3974516 C4.30769231,6.29461589 4.89189476,8.10651667 6.22190244,9.4402082 C7.62714975,10.849139 9.46525153,11.415587 10.5123552,11.415587 C11.0509871,11.3493607 11.4903192,10.9519835 11.6076923,10.4220969 C11.0810905,9.92835612 10.4822707,9.51892406 9.83234687,9.20887881 C9.70596545,9.23295082 9.58555184,9.28111374 9.47429766,9.35040108 C9.24555711,9.49182888 8.9867887,9.57313333 8.71895528,9.58819251 C8.04194973,9.58819251 6.13419842,7.67945573 6.13419842,7.00215167 C6.14322567,6.72511568 6.23351699,6.45420162 6.39595073,6.2284462 C6.44711141,6.15617347 6.48622318,6.0778922 6.51032101,5.99056029 C6.23351699,5.37035641 5.84234271,4.79840992 5.36389876,4.30769231"
                                id="Fill-3"
                                fill="#9B9B9B"
                              ></path>
                              <circle
                                id="椭圆形"
                                stroke="#727272"
                                cx="8"
                                cy="8"
                                r="8"
                              ></circle>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span>+65 6518 9877</span>
                  </div>
                </li>
                <li>
                  <div class="click_icon">
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 18 18"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="Home"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Page1-Home"
                          transform="translate(-1174.000000, -6772.000000)"
                        >
                          <g
                            id="foot"
                            transform="translate(0.000000, 6640.000000)"
                          >
                            <g
                              id="icon_email_foot"
                              transform="translate(1175.000000, 133.000000)"
                            >
                              <path
                                d="M11.0711771,6.25166975 L7.95957896,7.89815374 L4.92550596,6.29209281 C4.95492998,5.87151905 5.33621756,5.53846154 5.80242963,5.53846154 L10.1975704,5.53846154 C10.6490653,5.53846154 11.021392,5.84980605 11.0711771,6.25166975 Z M11.0769231,6.84143845 L11.0769231,9.3478174 C11.0769231,9.79313519 10.6833474,10.1538462 10.1975704,10.1538462 L5.80242963,10.1538462 C5.31661175,10.1538462 4.92307692,9.79313519 4.92307692,9.3478174 L4.92307692,6.884088 L7.82079719,8.41758202 C7.92038776,8.46994208 8.04042104,8.46022221 8.12697849,8.40182816 C8.13104049,8.40036877 8.13431663,8.39810486 8.13837864,8.39586901 L11.0769231,6.84143845 Z"
                                id="Fill-1"
                                fill="#9B9B9B"
                              ></path>
                              <circle
                                id="椭圆形备份-2"
                                stroke="#727272"
                                cx="8"
                                cy="8"
                                r="8"
                              ></circle>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span>info@pearlriverdecoration.com</span>
                  </div>
                </li>
                <li>
                  <div class="click_icon">
                    <svg
                      width="18px"
                      height="18px"
                      viewBox="0 0 18 18"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="Home"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="Page1-Home"
                          transform="translate(-1174.000000, -6800.000000)"
                        >
                          <g
                            id="foot"
                            transform="translate(0.000000, 6640.000000)"
                          >
                            <g
                              id="icon_adress_foot"
                              transform="translate(1175.000000, 161.000000)"
                            >
                              <path
                                d="M8.00288259,7.73864487 L7.99828083,7.73864487 C7.43404986,7.73864487 6.97575306,7.28038564 6.97575306,6.71615467 C6.97575306,6.15198004 7.43404986,5.69368103 7.99828083,5.69368103 L8.00057232,5.69368103 C8.56476573,5.69251872 9.02306252,6.14966978 9.02420827,6.71500893 C9.02420827,7.2792399 8.56707599,7.73748035 8.00288259,7.73864487 M8.00000884,4.30769231 C7.26446126,4.30769231 6.56050612,4.60000678 6.04176673,5.12007973 C5.52306492,5.64019024 5.23076923,6.34551652 5.23076923,7.07969297 C5.23076923,8.18433851 6.67027195,10.3840692 7.47304265,1..23304 C7.60339428,11.4873812 7.79554085,11.5765988 7.99863771,11.5765988 L8.00137997,11.5765988 C8.20447683,11.5765988 8.39658583,11.4873812 8.52693746,11.3323304 C9.32970816,10.3840692 10.7692308,8.18296737 10.7692308,7.07969297 C10.770582,5.54960149 9.53006275,4.30769231 8.00000884,4.30769231"
                                id="Fill-3"
                                fill="#9B9B9B"
                              ></path>
                              <circle
                                id="椭圆形备份"
                                stroke="#727272"
                                cx="8"
                                cy="8"
                                r="8"
                              ></circle>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                    <span
                      >2 Sims Close, #07-09, Singapore 387298</span
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="colophon" class="site-footer">
      <div class="container">
        <div class="copyright">
          &copy;2015 Pearl River Engineering Pte Ltd. All Rights Reserved
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainFoot",
  created() {
    this.path = this.$route.path;
  },
  data() {
    return {
      path: this.$route.path,
    };
  },
  methods: {
    nextIndex() {
      this.$router.push({ name: "index" });
    },
    nextHoming() {
      window.open("http://www.homing.sg/");
    },
  },
};
</script>

<style rel="stylesheet/less" type="text/less" lang="less" scoped>
.footer-logo {
  cursor: pointer;
  .foot_log {
    width: 63px;
  }
  svg {
    .st0 {
      fill: url(#SVGID_1_);
    }
    .st1 {
      fill: url(#SVGID_2_);
    }
    .st2 {
      fill: url(#SVGID_3_);
    }
    .st3 {
      fill: url(#SVGID_4_);
    }
    .st4 {
      fill: url(#SVGID_5_);
    }
    .st5 {
      fill: url(#SVGID_6_);
    }
    .st6 {
      fill: url(#SVGID_7_);
    }
    .st7 {
      fill: url(#SVGID_8_);
    }
    .st8 {
      fill: url(#SVGID_9_);
    }
    .st9 {
      fill: url(#SVGID_10_);
    }
    .st10 {
      fill: url(#SVGID_11_);
    }
    .st11 {
      fill: url(#SVGID_12_);
    }
    .st12 {
      fill: url(#SVGID_13_);
    }
    .st13 {
      fill: url(#SVGID_14_);
    }
    .st14 {
      fill: url(#SVGID_15_);
    }
    .st15 {
      fill: url(#SVGID_16_);
    }
    .st16 {
      fill: url(#SVGID_17_);
    }
    .st17 {
      fill: url(#SVGID_18_);
    }
    .st18 {
      fill: url(#SVGID_19_);
    }
    .st19 {
      fill: url(#SVGID_20_);
    }
    .st20 {
      fill: url(#SVGID_21_);
    }
  }
}
.line {
  height: 94px;
  border-left: 2px solid #d4d4d4;
}
.associate-logo-item {
  display: flex;
  text-align: left;
  padding: 0 60px;
  .item_icon {
    margin-right: 30px;
  }
  .item_right {
    display: flex;
    flex-direction: column;
    .title_text {
      font-size: 22px;
      color: #000000;
      font-weight: 600;
    }
    p {
      padding: 0 20px 0 0;
    }
  }
}
.foot_logo > :first-child {
  padding: 0 25px;
  p {
    padding-right: 50px;
  }
}
.footer_left {
  width: 120px;
  float: left;
}
.click_icon {
  svg {
    position: absolute;
    left: 3px;
    top: 6px;
  }
}
.contavctus {
  float: left;
  padding: 0 25px;
  font-size: 14px;
  color: #727272;
  span {
    margin-left: 15px;
  }
}
</style>
